<div class="flex items-center gap-3">
  <!--  <span [ngClass]="{ checked: checked, disabled: disabled }" class="checkbox"></span>-->
  <app-checkbox class="small" [ngModel]="checked" [binary]="true"></app-checkbox>
  <div class="flex-1 min-w-0">
    <div
      [ngClass]="{
        'text-navy-900': !disabled,
        'text-navy-500': disabled
      }"
      class="text-size_l font-semibold overflow-ellipsis whitespace-nowrap overflow-hidden"
    >
      {{ title }}
    </div>
    @if (subtitle) {
      <div
        [ngClass]="{
          'text-navy-700': !disabled,
          'text-navy-500': disabled
        }"
        class="text-size_m font-normal"
      >
        {{ subtitle }}
      </div>
    }
  </div>
</div>
